function removeABTestVariant(isKeepAbTestId = true) {
  if (!isKeepAbTestId) {
    localStorage.removeItem('abTestId');
  }
  localStorage.removeItem('abTestVariant');
  localStorage.removeItem('abTestCustomerId');
  utils.mixpanelRetryWrapper.unregister("product_page_test");
}

async function getABTestVariant() {
  const VALID_AB_VARIANT_NAMES = ['control_july2026', 'variant_july2026'];
  try {
    const abTestId = localStorage.getItem('abTestId');
    // const abTestStatus = localStorage.getItem('abTestStatus');
    const abTestUrl = `${window.location.origin}/apps/${APP_PROXY_NAME}/app/abtest`;
    const abTestRes = await fetch(abTestUrl, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    });
    if (!abTestRes.ok) {
      throw new Error('Network response was not ok');
    }
    const abTestData = await abTestRes.json();
    if (!abTestData || !abTestData.id) {
      console.log("ab test id not exist");
      removeABTestVariant(false);
      return;
    }
    // check if abTestId is different from localStorage
    if (String(abTestId) !== String(abTestData.id)) {
      removeABTestVariant();
      localStorage.setItem('abTestId', abTestData.id);
    }
    const customerId =
      typeof window !== 'undefined' && window.shopifyCustomer
        ? window.shopifyCustomer.customerId
        : null;
    //get deviceId from cookie, if not exist, create new deviceId and set to cookie
    let abTestDeviceId = localStorage.getItem('abTestDeviceId');
    const abTestVariant = localStorage.getItem('abTestVariant');
    // const abTestCustomerId = localStorage.getItem('abTestCustomerId');

    let variantObj = null;
    try {
      variantObj = abTestVariant ? JSON.parse(abTestVariant) : null;
    } catch (e) {
      console.log("Error when parse abTestVariant:", e);
    }
    if (variantObj?.name && VALID_AB_VARIANT_NAMES.includes(variantObj.name)) {
      utils.mixpanelRetryWrapper.register({ "product_page_test": variantObj.name });
      return;
    }

    // Fetching new AB test variant
    removeABTestVariant();
    abTestDeviceId = null;

    // if abTestDeviceId not exist, create new deviceId and set to cookie
    if (!abTestDeviceId) {
      // Using Web Crypto API for generating unique device ID for A/B testing
      // This is a standard browser API (not malicious code)
      abTestDeviceId = crypto.randomUUID();
      localStorage.setItem('abTestDeviceId', abTestDeviceId);
    }
    // fetch
    const url = `${window.location.origin}/apps/${APP_PROXY_NAME}/app/abtest-variant?deviceId=${abTestDeviceId}&${customerId ? `customerId=${customerId}` : ''}`;
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    });
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    let data = await response.json();
    const variantName = data?.variant?.name;
    console.log("Variant name - getABTestVariant:", variantName, VALID_AB_VARIANT_NAMES);
    if (variantName && VALID_AB_VARIANT_NAMES.includes(variantName)) {
      localStorage.setItem('abTestVariant', JSON.stringify(data.variant));
      localStorage.setItem('abTestCustomerId', customerId);
      utils.mixpanelRetryWrapper.register({ "product_page_test": variantName });
    }
  } catch (error) {
    console.log("Error - getABTestVariant:", error);
  } finally {
    if (utils && utils.mixpanelRetryWrapper && utils.mixpanelRetryWrapper.removePendingTask) {
      utils.mixpanelRetryWrapper.removePendingTask('abTest');
    }
  }
}

// getABTestVariant();
